export const PRODUCT_GET = 'productGet';
export const PRODUCTS_GET = 'productsGet';
export const PRODUCT_CREATE = 'productCreate';
export const PRODUCT_UPDATE = 'productUpdate';
export const PARAMETERS_GET = 'parametersGet';
export const PRODUCT_SEARCH = 'productSearch';
export const PRODUCT_SEARCH_SIMPLE = 'productSearchSimple'
export const PRODUCT_BRAND_SEARCH = 'productBrandSearch';
export const PRODUCTS_SIMPLE_GET = 'productsSimpleGet';
export const PRODUCT_UPDATE_STOCK = 'productUpdateStock';
export const PRODUCT_ACTIVE = 'productActive';
export const PRODUCT_INACTIVE = 'productInactive';
export const PRODUCT_DELETE = 'productDelete';

